"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalWidth = void 0;
const use_window_size_1 = require("./use-window-size");
const MAX_WIDTH_FOR_DESKTOP = 744;
const MAX_WIDTH = 1024;
const PADDING = 48;
const useModalWidth = () => {
    const [width] = (0, use_window_size_1.useWindowSize)();
    return width > MAX_WIDTH ? MAX_WIDTH_FOR_DESKTOP : width - PADDING;
};
exports.useModalWidth = useModalWidth;
